import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=47ac8649"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=47ac8649&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports